module.exports = __webpack_public_path__ + "ce01c845c370b68575ae1204b0c27f5b.jpg";